<div
  (click)='isEnabled ? openMenu.emit(item): null'
  [disableTooltip]='!showLabelTooltip'
  [ngClass]='{
        "sidebar-link--collapsed": collapsed,
        "sidebar-link--disabled": !isEnabled
  }'
  [ngbTooltip]='item?.label | async'
  class='sidebar-link'
  container='body'
  placement='right'
  tooltipClass='side-bar-tooltip'
>

  <pt-icon *ngIf='item?.icon'
           [iconType]="item.icon?.type"
           [key]='item.icon?.key'
           [size]="16">
  </pt-icon>
  <label *ngIf='!collapsed'>
    {{ item?.label | async }}
  </label>

</div>
